import { render, staticRenderFns } from "./PageGroupTree.vue?vue&type=template&id=6fce8a2a&scoped=true&"
import script from "./PageGroupTree.vue?vue&type=script&lang=js&"
export * from "./PageGroupTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fce8a2a",
  null
  
)

export default component.exports